/**
 * @file 首页常量
 * @author zhanghaohan
 */

import prompt2 from '../assets/images/home/prompt2.png';
import prompt1 from '../assets/images/home/prompt1.png';
import prompt3 from '../assets/images/home/prompt3.png';
import slider1 from '../assets/images/home/slider1.gif';
import slider2 from '../assets/images/home/slider2.gif';
import slider3 from '../assets/images/home/slider3.gif';
import slider4 from '../assets/images/home/slider4.gif';
import slider5 from '../assets/images/home/slider5.gif';

// 首页素材常量

export const HUIBO_VIDEO_CASE = [
    {
        key: 0,
        url: 'https://live-cecom-image.cdn.bcebos.com/ambience_icon/2024-1/1704780927996/5cc43676e12b.mp4',
        title: '专业主播形象',
        poster: 'https://mpics.bdstatic.com/qm/202401/pic_35I2J5_1704780927.png'
    }, {
        key: 1,
        url: 'https://huibo-data.cdn.bcebos.com/upload/b29e63e3345b14470ba89dab4e95f2da.mp4',
        title: '多样风格播报',
        poster: 'https://huibo-data.cdn.bcebos.com/upload/2b94c66097871ad2df37c176e4613fbc.jpeg'
    },
    {
        key: 2,
        url: 'https://huibo-data.cdn.bcebos.com/upload/14bc1f359b59e0016ccaeed283a40a2e.mp4',
        title: '一键生成语料',
        poster: 'https://huibo-data.cdn.bcebos.com/upload/f653ff3e8838ef6fcd2e920413995086.jpeg'
    },
    {
        key: 3,
        url: 'https://huibo-data.cdn.bcebos.com/upload/47d2b4447b7943bb6609a3f4a150622b.mp4',
        title: '智能直播间装修',
        poster: 'https://huibo-data.cdn.bcebos.com/upload/90022c413f12ecd6243dbacb9a506b0d.jpeg'
    }

];
export const HUIBO_BROADCAST_WORKFLOW = [
    {id: 1,
        img: prompt1,
        title: '生成数字人主播',
        desc: '公共库选择形象与声音，\n真人录制形象定制数字人+真人录音'
    }, {
        id: 2,
        img: prompt2,
        title: '为数字人装上大脑',
        desc: 'AI生成剧本、问答与互动，\n录入剧本AI优化，自定义问答互动文案'
    }, {
        id: 3,
        img: prompt3,
        title: '装修数字人直播间',
        desc: 'AI生成素材图,\n配置图片与视频'
    }
];
export const HUIBO_TECHNOLOGICAL_EDGE = [
    {id: 0, title: '文心多模态大模型', desc: '基于飞桨深度学习平台和文心知识增强大模型，持续从海量数据和大规模知识中融合学习。基于商品详情页，可轻松完成智能问答生成、脚本文案创作等多种任务。', img: slider1},
    {id: 1, title: '自然语言处理', desc: '国际领先的自然语言处理技术，赋能电商场景，提供卓越的语言理解和语言生成能力。模拟真人互动。', img: slider5},
    {id: 2, title: '语音技术能力', desc: '与文心大模型及语音大模型能力深度结合，实现直播场景TTS的个性化复刻，到达超越真人直播效果。', img: slider3},
    {id: 3, title: '图像识别处理', desc: '国际领先的图像识别及处理技术，利用海量图像、视频等数据，为电商场景提供强大的图像素材支持。轻松实现一键装修直播间，让设计不再困扰。', img: slider2},
    {id: 4, title: '计算机视觉', desc: '百度视觉人像唇形驱动技术，分钟级数字人建模，具有绝对的技术领先性。', img: slider4}
];

export const HUIBO_EXEMPLARY_CASE = [
    {id: 0, title: '苏宁电脑官方', desc: '苏宁数字人通过智能脚本自主思考规划，进行电竞本塑品种草；并通过智能问答与用户互动交流、有效沟通，再结合智能场控随机应变，实时动态优化、调整带货节奏，有效提高直播间互动与转化', gmv: {name: 'GMV提升', value: '50万+'}, order: {name: '粉丝增量', value: '+32%'}, time: {name: '粉丝贡献GMV占比', value: '+82.1%'}, video: 'https://huibo-data.cdn.bcebos.com/upload/a64d3c687942b51cae252681e43639d9.mp4', poster: 'https://huibo-data.cdn.bcebos.com/upload/80ee02ed68a24c1f61ab3d28da86842f.png'},
    {id: 1, title: '观心实验室', desc: '教育培训数字人商家，凭借在心理数字疗法的长期深耕，以及数字人直播矩阵的强效加持，有效拔高增长空间，实现订单量翻倍', gmv: {name: '数字人矩阵gmv', value: '+200%'}, order: {name: '直播时长对比真人', value: '+5倍'}, time: {name: '转化率对比真人', value: '+100%'}, video: 'https://huibo-data.cdn.bcebos.com/upload/c08080a2c44a20117385e672f66e4ebd.mp4', poster: 'https://huibo-data.cdn.bcebos.com/upload/14535492a9e26c7893f2881ee7e7c8f9.png'},
    {id: 2, title: '东北翠花在东北', desc: '特色农产品创作者，通过数字人开启短视频内容创作与数字人直播新模式，结合自身具备的强烈地域风格，账号粉丝量显著增加，并带来大幅收益增长，极大赋能了翠花作为创作者的发展前景', gmv: {name: '数字人直播季度GMV提升', value: '50万'}, order: {name: '数字人贡献粉丝增量', value: '+22%'}, time: {name: '粉丝贡献GMV占比', value: '80%'}, video: 'https://huibo-data.cdn.bcebos.com/upload/7611d013e6e710bf776475351e9dc7d7.mp4', poster: 'https://huibo-data.cdn.bcebos.com/upload/befadbffbdbfc4ac6a307f2736e1071c.png'},
    {id: 3, title: '齐家', desc: '家居家装数字人直播间，借助直播留咨获客场景，挂载留咨表单，带线索、引客户，搭配数字人主播专业讲解与引导，有效带来大量线索', gmv: {name: '直播间单场线索留存', value: '200+'}, order: {name: '场观提升', value: '+200%'}, time: {name: '优质回答率', value: '55%'}, video: 'https://huibo-data.cdn.bcebos.com/upload/c73d926b7b22afcfc1191af863a63726.mp4', poster: 'https://huibo-data.cdn.bcebos.com/upload/ab71a29618ae973a4e5bacdd878144a5.png'}
];

export const ESHOP_IFRAME_CONFIG = {
    myColumn: {
        show: false
    },
    myCircle: {
        show: false
    },
    myLive: {
        show: false
    },
    columnLib: {
        show: false
    },
    editorSelect: {
        show: false
    },
    batchSelect: {
        show: false
    },
    myMiniapp: {
        show: true
    },
    directed: {
        show: true
    },
    mode: 1
};

export const HUIBO_SCRIPT_ROOKIE_GUIDE_IS_USE = 'huibo_script_rookie_guide_is_use';
export const HUIBO_EDITOR_ROOKIE_GUIDE_IS_USE = 'huibo_editor_rookie_guide_is_use';

export const HUIBO_CHARACTER_TUTORIAL = 'huibo_character_tutorial_is_show';
